import {
  createFetchActionForNamespace,
  createPostActionForNamespace
} from 'utils/reducers';

const createFetchAction = createFetchActionForNamespace('agreementUsers');
const createPostAction = createPostActionForNamespace('agreementUsers');

export const fetchAgreementUser = createFetchAction({
  name: 'FETCH_AGREEMENT_USER',
  initialAction: ({agreementUserId}, extraActions = []) => ({
    payload: {agreementUserId, extraActions}
  })
});

export const updateAgreementUser = createPostAction({
  name: 'UPDATE_AGREEMENT_USER',
  initialAction: (
    {
      agreementUserId,
      fullName,
      email,
      phone,
      gender,
      birthday,
      nationality,
      countryOfOrigin,
      countryCode,
      location
    },
    extraActions = []
  ) => ({
    payload: {
      agreementUserId,
      fullName,
      email,
      phone,
      gender,
      birthday,
      nationality,
      countryOfOrigin,
      countryCode,
      location,
      extraActions
    }
  }),
  formName: 'agreementUserEdit'
});

export const verifyAgreementUserInternalAvatarUpload = createPostAction({
  name: 'VERIFY_AGREMENT_USER_INTERNAL_AVATAR_UPLOAD',
  initialAction: ({agreementUserId, identifier}, extraActions = []) => ({
    payload: {
      agreementUserId,
      identifier,
      extraActions
    }
  })
});

//This delay is needed because the call to S3 is slower than the fetch we make again
export const REFETCH_AVATARS_DELAY = 500;

export const MODALS = {
  AGREEMENT_USER_INFO: 'agreementUserInfo'
};

export {default as agreementUsersSaga} from './saga';
